import { ReactNode } from "react";

type PageHeaderProps = {
  overline?: string;
  title: string;
  description?: string;
  badgeTitle?: string;
  badgeDescription?: string;
  actions?: ReactNode;
};

export function PageHeader({ overline, title, description, actions }: PageHeaderProps) {
  return (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-4">
      <div>
        {overline ? (
          <p className="mb-1 text-[10px] font-semibold uppercase tracking-[0.06em] text-[var(--text-muted)]">
            {overline}
          </p>
        ) : null}
        <h1 className="text-[20px] font-bold leading-tight text-[var(--foreground)]">
          {title}
        </h1>
        {description ? (
          <p className="mt-1 text-[13px] text-[var(--muted-foreground)]">{description}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}
